import { handleActions } from 'redux-actions';
import * as filtersActions from '../actions/filters';

let initState = {
  count: 0,
  fields: null,
  search: null,
};

export const filters = handleActions(
  {
    [filtersActions.updateFilterFieldsVehicles]: (state, action) => {
      return {
        ...state,
        fields: action.payload,
      };
    },
    [filtersActions.searchVehicles]: (state, action) => {
      return {
        ...state,
        search: action.payload,
      };
    },
    [filtersActions.countFiltersVehicles]: (state, action) => {
      return {
        ...state,
        count: action.payload,
      };
    },
    [filtersActions.resetFiltersVehicles]: (state, action) => {
      return {
        ...state,
        fields: null,
        search: null,
        count: 0,
      };
    },
  },
  initState
);
